import { defineComponent as T, ref as y, computed as R, provide as N, onMounted as B, onUnmounted as K, watchEffect as L, nextTick as h, inject as $ } from "vue";
import { useId as D } from "./index327.js";
import { useOutsideClick as j } from "./index328.js";
import { useResolveButtonType as U } from "./index329.js";
import { useTextValue as V } from "./index357.js";
import { useTrackedPointer as _ } from "./index330.js";
import { useTreeWalker as q } from "./index331.js";
import { useOpenClosedProvider as Q, useOpenClosed as W, State as x } from "./index333.js";
import { Keys as c } from "./index334.js";
import { calculateActiveIndex as H, Focus as I } from "./index337.js";
import { dom as v } from "./index339.js";
import { isFocusableElement as J, sortByDomNode as Z, FocusableMode as z, focusFrom as G, Focus as F, restoreFocusIfNecessary as A } from "./index340.js";
import { match as X } from "./index342.js";
import { render as k, Features as O } from "./index345.js";
var Y = ((a) => (a[a.Open = 0] = "Open", a[a.Closed = 1] = "Closed", a))(Y || {}), ee = ((a) => (a[a.Pointer = 0] = "Pointer", a[a.Other = 1] = "Other", a))(ee || {});
function te(a) {
  requestAnimationFrame(() => requestAnimationFrame(a));
}
let C = Symbol("MenuContext");
function w(a) {
  let b = $(C, null);
  if (b === null) {
    let g = new Error(`<${a} /> is missing a parent <Menu /> component.`);
    throw Error.captureStackTrace && Error.captureStackTrace(g, w), g;
  }
  return b;
}
let Ie = T({ name: "Menu", props: { as: { type: [Object, String], default: "template" } }, setup(a, { slots: b, attrs: g }) {
  let m = y(1), f = y(null), p = y(null), e = y([]), s = y(""), u = y(null), M = y(1);
  function S(t = (l) => l) {
    let l = u.value !== null ? e.value[u.value] : null, n = Z(t(e.value.slice()), (d) => v(d.dataRef.domRef)), o = l ? n.indexOf(l) : null;
    return o === -1 && (o = null), { items: n, activeItemIndex: o };
  }
  let r = { menuState: m, buttonRef: f, itemsRef: p, items: e, searchQuery: s, activeItemIndex: u, activationTrigger: M, closeMenu: () => {
    m.value = 1, u.value = null;
  }, openMenu: () => m.value = 0, goToItem(t, l, n) {
    let o = S(), d = H(t === I.Specific ? { focus: I.Specific, id: l } : { focus: t }, { resolveItems: () => o.items, resolveActiveIndex: () => o.activeItemIndex, resolveId: (i) => i.id, resolveDisabled: (i) => i.dataRef.disabled });
    s.value = "", u.value = d, M.value = n ?? 1, e.value = o.items;
  }, search(t) {
    let l = s.value !== "" ? 0 : 1;
    s.value += t.toLowerCase();
    let n = (u.value !== null ? e.value.slice(u.value + l).concat(e.value.slice(0, u.value + l)) : e.value).find((d) => d.dataRef.textValue.startsWith(s.value) && !d.dataRef.disabled), o = n ? e.value.indexOf(n) : -1;
    o === -1 || o === u.value || (u.value = o, M.value = 1);
  }, clearSearch() {
    s.value = "";
  }, registerItem(t, l) {
    let n = S((o) => [...o, { id: t, dataRef: l }]);
    e.value = n.items, u.value = n.activeItemIndex, M.value = 1;
  }, unregisterItem(t) {
    let l = S((n) => {
      let o = n.findIndex((d) => d.id === t);
      return o !== -1 && n.splice(o, 1), n;
    });
    e.value = l.items, u.value = l.activeItemIndex, M.value = 1;
  } };
  return j([f, p], (t, l) => {
    var n;
    r.closeMenu(), J(l, z.Loose) || (t.preventDefault(), (n = v(f)) == null || n.focus());
  }, R(() => m.value === 0)), N(C, r), Q(R(() => X(m.value, { 0: x.Open, 1: x.Closed }))), () => {
    let t = { open: m.value === 0, close: r.closeMenu };
    return k({ ourProps: {}, theirProps: a, slot: t, slots: b, attrs: g, name: "Menu" });
  };
} }), be = T({ name: "MenuButton", props: { disabled: { type: Boolean, default: !1 }, as: { type: [Object, String], default: "button" }, id: { type: String, default: null } }, setup(a, { attrs: b, slots: g, expose: m }) {
  var f;
  let p = (f = a.id) != null ? f : `headlessui-menu-button-${D()}`, e = w("MenuButton");
  m({ el: e.buttonRef, $el: e.buttonRef });
  function s(r) {
    switch (r.key) {
      case c.Space:
      case c.Enter:
      case c.ArrowDown:
        r.preventDefault(), r.stopPropagation(), e.openMenu(), h(() => {
          var t;
          (t = v(e.itemsRef)) == null || t.focus({ preventScroll: !0 }), e.goToItem(I.First);
        });
        break;
      case c.ArrowUp:
        r.preventDefault(), r.stopPropagation(), e.openMenu(), h(() => {
          var t;
          (t = v(e.itemsRef)) == null || t.focus({ preventScroll: !0 }), e.goToItem(I.Last);
        });
        break;
    }
  }
  function u(r) {
    switch (r.key) {
      case c.Space:
        r.preventDefault();
        break;
    }
  }
  function M(r) {
    a.disabled || (e.menuState.value === 0 ? (e.closeMenu(), h(() => {
      var t;
      return (t = v(e.buttonRef)) == null ? void 0 : t.focus({ preventScroll: !0 });
    })) : (r.preventDefault(), e.openMenu(), te(() => {
      var t;
      return (t = v(e.itemsRef)) == null ? void 0 : t.focus({ preventScroll: !0 });
    })));
  }
  let S = U(R(() => ({ as: a.as, type: b.type })), e.buttonRef);
  return () => {
    var r;
    let t = { open: e.menuState.value === 0 }, { ...l } = a, n = { ref: e.buttonRef, id: p, type: S.value, "aria-haspopup": "menu", "aria-controls": (r = v(e.itemsRef)) == null ? void 0 : r.id, "aria-expanded": e.menuState.value === 0, onKeydown: s, onKeyup: u, onClick: M };
    return k({ ourProps: n, theirProps: l, slot: t, attrs: b, slots: g, name: "MenuButton" });
  };
} }), ge = T({ name: "MenuItems", props: { as: { type: [Object, String], default: "div" }, static: { type: Boolean, default: !1 }, unmount: { type: Boolean, default: !0 }, id: { type: String, default: null } }, setup(a, { attrs: b, slots: g, expose: m }) {
  var f;
  let p = (f = a.id) != null ? f : `headlessui-menu-items-${D()}`, e = w("MenuItems"), s = y(null);
  m({ el: e.itemsRef, $el: e.itemsRef }), q({ container: R(() => v(e.itemsRef)), enabled: R(() => e.menuState.value === 0), accept(t) {
    return t.getAttribute("role") === "menuitem" ? NodeFilter.FILTER_REJECT : t.hasAttribute("role") ? NodeFilter.FILTER_SKIP : NodeFilter.FILTER_ACCEPT;
  }, walk(t) {
    t.setAttribute("role", "none");
  } });
  function u(t) {
    var l;
    switch (s.value && clearTimeout(s.value), t.key) {
      case c.Space:
        if (e.searchQuery.value !== "") return t.preventDefault(), t.stopPropagation(), e.search(t.key);
      case c.Enter:
        if (t.preventDefault(), t.stopPropagation(), e.activeItemIndex.value !== null) {
          let n = e.items.value[e.activeItemIndex.value];
          (l = v(n.dataRef.domRef)) == null || l.click();
        }
        e.closeMenu(), A(v(e.buttonRef));
        break;
      case c.ArrowDown:
        return t.preventDefault(), t.stopPropagation(), e.goToItem(I.Next);
      case c.ArrowUp:
        return t.preventDefault(), t.stopPropagation(), e.goToItem(I.Previous);
      case c.Home:
      case c.PageUp:
        return t.preventDefault(), t.stopPropagation(), e.goToItem(I.First);
      case c.End:
      case c.PageDown:
        return t.preventDefault(), t.stopPropagation(), e.goToItem(I.Last);
      case c.Escape:
        t.preventDefault(), t.stopPropagation(), e.closeMenu(), h(() => {
          var n;
          return (n = v(e.buttonRef)) == null ? void 0 : n.focus({ preventScroll: !0 });
        });
        break;
      case c.Tab:
        t.preventDefault(), t.stopPropagation(), e.closeMenu(), h(() => G(v(e.buttonRef), t.shiftKey ? F.Previous : F.Next));
        break;
      default:
        t.key.length === 1 && (e.search(t.key), s.value = setTimeout(() => e.clearSearch(), 350));
        break;
    }
  }
  function M(t) {
    switch (t.key) {
      case c.Space:
        t.preventDefault();
        break;
    }
  }
  let S = W(), r = R(() => S !== null ? (S.value & x.Open) === x.Open : e.menuState.value === 0);
  return () => {
    var t, l;
    let n = { open: e.menuState.value === 0 }, { ...o } = a, d = { "aria-activedescendant": e.activeItemIndex.value === null || (t = e.items.value[e.activeItemIndex.value]) == null ? void 0 : t.id, "aria-labelledby": (l = v(e.buttonRef)) == null ? void 0 : l.id, id: p, onKeydown: u, onKeyup: M, role: "menu", tabIndex: 0, ref: e.itemsRef };
    return k({ ourProps: d, theirProps: o, slot: n, attrs: b, slots: g, features: O.RenderStrategy | O.Static, visible: r.value, name: "MenuItems" });
  };
} }), Me = T({ name: "MenuItem", inheritAttrs: !1, props: { as: { type: [Object, String], default: "template" }, disabled: { type: Boolean, default: !1 }, id: { type: String, default: null } }, setup(a, { slots: b, attrs: g, expose: m }) {
  var f;
  let p = (f = a.id) != null ? f : `headlessui-menu-item-${D()}`, e = w("MenuItem"), s = y(null);
  m({ el: s, $el: s });
  let u = R(() => e.activeItemIndex.value !== null ? e.items.value[e.activeItemIndex.value].id === p : !1), M = V(s), S = R(() => ({ disabled: a.disabled, get textValue() {
    return M();
  }, domRef: s }));
  B(() => e.registerItem(p, S)), K(() => e.unregisterItem(p)), L(() => {
    e.menuState.value === 0 && u.value && e.activationTrigger.value !== 0 && h(() => {
      var i, P;
      return (P = (i = v(s)) == null ? void 0 : i.scrollIntoView) == null ? void 0 : P.call(i, { block: "nearest" });
    });
  });
  function r(i) {
    if (a.disabled) return i.preventDefault();
    e.closeMenu(), A(v(e.buttonRef));
  }
  function t() {
    if (a.disabled) return e.goToItem(I.Nothing);
    e.goToItem(I.Specific, p);
  }
  let l = _();
  function n(i) {
    l.update(i);
  }
  function o(i) {
    l.wasMoved(i) && (a.disabled || u.value || e.goToItem(I.Specific, p, 0));
  }
  function d(i) {
    l.wasMoved(i) && (a.disabled || u.value && e.goToItem(I.Nothing));
  }
  return () => {
    let { disabled: i, ...P } = a, E = { active: u.value, disabled: i, close: e.closeMenu };
    return k({ ourProps: { id: p, ref: s, role: "menuitem", tabIndex: i === !0 ? void 0 : -1, "aria-disabled": i === !0 ? !0 : void 0, onClick: r, onFocus: t, onPointerenter: n, onMouseenter: n, onPointermove: o, onMousemove: o, onPointerleave: d, onMouseleave: d }, theirProps: { ...g, ...P }, slot: E, attrs: g, slots: b, name: "MenuItem" });
  };
} });
export {
  Ie as Menu,
  be as MenuButton,
  Me as MenuItem,
  ge as MenuItems
};
